module.exports = __webpack_public_path__ + "files/ae4b6d3516d43b30d1dbca47d487efba.svg";